<template>
    <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; width: 100%;">
        <div style="font-size: 6em;">404</div>
        <h1 style="margin-top: 0;">Page not found</h1>
        <div>The page you are looking for doesn't exists or an other error occured.</div>

    </div>
</template>

<script setup lang="ts">

</script>

<style scoped></style>